import classnames from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import styles from './FootprintButton.module.scss';

export interface IFootprintButtonProps extends IBaseProps {
  buttonType?: 'button' | 'submit';
  /** Defines the style variant of the button */
  variant?: 'light' | 'dark';
  /** Adds a `title` attribute to <button>, which can be used to provide screenreader users additional context */
  title?: string;
  /** Determines if button is disabled. */
  disabled?: boolean;
  /** Callback for when the button is clicked by the user. If the button is disabled, the callback will not called. */
  onClick?(event?);
}

export const ButtonDefaultProps: Partial<IFootprintButtonProps> = {
  buttonType: 'button',
  variant: 'light'
};

export const FootprintButton: React.FC<IFootprintButtonProps> = (props) => {
  const disabled = props.disabled;
  const stylesMap = classnames(
    {
      [styles.disabled]: props.disabled
    },
    styles.footprintStyle,
    props.className,
    props.variant === 'dark' && styles.dark
  );
  return (
    <button
      title={props.title}
      type={props.buttonType || 'button'}
      data-test={props.dataTest}
      className={stylesMap}
      onClick={disabled ? null : props.onClick || null}
      disabled={disabled}
    >
      &#43; {props.children}
    </button>
  );
};
